<template>
  <div class="skeleton-loading-circle" :style="{ height, width, 'border-radius': radius }">
  </div>
</template>

<style lang="scss" scoped>
.skeleton-loading-circle {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #DDDBDD;
  top: 0;
  left: 0;
  border-radius: 64px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 1.5s infinite;
    content: '';
  }
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>

<script>
export default {
  name: 'SkeletonCircle',
  props: {
    height: {
      type: String,
      default: '128px',
    },
    width: {
      type: String,
      default: '128px',
    },
    radius: {
      type: String,
      default: '64px',
    },
  }
}
</script>